<div class="checkin__booking__localizer">
  <div class="checkin__booking__localizer__box" [@flipAnimation]="flipAnimationState">
    <div class="checkin__booking__localizer__side checkin__booking__localizer__side--front" [@slideAnimation]="!slideAnimationState">
      <div class="checkin__booking__localizer__content">
        <form
          #formElem
          class="checkin__booking__localizer__form"
          [ngClass]="{ 'checkin__form--invalid': submitted && !form.valid }"
          [formGroup]="form"
          (keyup.enter)="onSubmit()">
          <div>
            <h2>{{ 'do-your-checkin' | translate }}</h2>
            <div class="checkin__booking__localizer__input">
              <app-input-text
                [form]="form"
                customClass="checkin__booking__localizer__input"
                [label]="'localizer-booking' | translate"
                [required]="true"
                [control]="'localizer'"
                (focus)="removeErrored()">
              </app-input-text>
            </div>
            <div class="checkin__booking__localizer__input">
              <app-input-text
                [form]="form"
                customClass="checkin__booking__localizer__input"
                [label]="'firstname-booking-holder' | translate"
                [required]="true"
                [control]="'firstName'"
                (focus)="removeErrored()">
              </app-input-text>
              <span class="checkin__booking__localizer--error" *ngIf="errored">
                {{ 'booking-not-found' | translate }}
              </span>
            </div>
          </div>
          <app-button-primary
            customClass="checkin__booking__localizer__button"
            text="next"
            (buttonClick)="onSubmit()">
          </app-button-primary>
        </form>
        <div class="checkin__booking__localizer__explanation__link" (click)="toggleExplanation()">{{ 'where-find-localizer' | translate }}</div>
      </div>
    </div>
    <div class="checkin__booking__localizer__side checkin__booking__localizer__side--back" [@slideAnimation]="slideAnimationState">
      <div class="checkin__booking__localizer__content">
        <h2>{{ 'where-find-localizer' | translate }}</h2>
        <p class="checkin__booking__localizer__explanation__text" [innerHTML]="'where-find-localizer-text' | translate"></p>
        <p class="checkin__booking__localizer__explanation__example">10893815</p>
        <div class="checkin__booking__localizer__spacer"></div>
        <app-button-primary
          customClass="checkin__booking__localizer__button"
          [text]="'understood' | translate"
          (buttonClick)="toggleExplanation()">
        </app-button-primary>
      </div>
    </div>
  </div>
</div>
